import { AxiosResponse } from "axios";
import axiosInstance from "../../../../interceptors/axiosInstance";
import { ArgumentosCargarArchivoCobro } from "../models/cargaCobro";

const listarCarga = async (data: File) => {
    const formData = new FormData();
    formData.append("archivoCsv", data);
    const response: AxiosResponse = await axiosInstance.post(`siscred-api-dividendos/v1/minvu/listar-minvu-cobro`, formData);
    return response;
}
const cargarArchivo = async (data: ArgumentosCargarArchivoCobro) => {
    const response: AxiosResponse = await axiosInstance.post(`siscred-api-dividendos/v1/minvu/cargar-minvu-cobro`, data);
    return response;
}

export { listarCarga, cargarArchivo };